<div [class]="'min-w-[120px] h-5 px-6 rounded-[40px] justify-center items-center inline-flex ' + bgColor">
    <span [class]="'text-center text-white text-[8px] font-[\'Poppins\'] leading-normal ' + textColor">
        {{ text }}
    </span>
</div>